import { createStyles } from '@material-ui/core/styles';

export default () => createStyles({
  root: {
    padding: 16,
    borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'visible',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 12,
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  title: {
    fontWeight: 600,
    fontSize: 18,
  },
  badge: {
    background: '#DB5C0E',
    width: 25,
    height: 25,
    borderRadius: '50%',
    fontSize: 12,
    fontWeight: 600,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 0',
    borderBottom: '1px solid #eae5e5',
    '&:last-child': { borderBottom: 'none' },
  },
  listBody: {
    flex: 1,
    overflowY: 'auto',
    overflow: 'hidden',
  },
  itemLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
  },
  iconWrap: {
    width: 36,
    height: 36,
    borderRadius: 8,
    background: '#f5f5f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16,
    flexShrink: 0,
  },
  icon: {
    color: '#DB5C0E',
  },
  name: {
    fontWeight: 600,
    fontSize: 14,
    marginBottom: 2,
  },
  community: {
    fontSize: 13,
    color: '#4d4a4a',
    fontWeight: 600,
  },
  address: {
    fontSize: 12,
    color: '#6d6a6a',
    fontWeight: 600,
  },
  lot: {
    fontSize: 12,
    color: '#6d6a6a',
    gap: '5px',
  },
  createdAt: {
    fontSize: 12,
    color: '#6d6a6a',
  },
  statusBadge: {
    padding: '3px 10px',
    borderRadius: 12,
    fontSize: 12,
    fontWeight: 600,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    display: 'inline-block',
    marginRight: 4,
  },
  activePropertiesBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    backgroundColor: '#f0f4ff',
    color: '#4a6cf7',
    fontSize: '11px',
    fontWeight: 500,
    padding: '2px 8px',
    borderRadius: '12px',
    marginLeft: '8px',
  },
});
